export class FirmaBilgileri {
  id?: number = null;
  ad?: string = null;
  firmaKisaAd?: string = null;
  yetkiliKisi?: string = null;
  kurulusYili?: number = null;
  logo?: string = null;
  favIcon?: string = null;
  slogan?: string = null;
  vergiDairesi?: string = null;
  vergiNo?: string = null;
  sicilNo?: string = null;
  mersisNo?: string = null;
  adres?: string = null;
  googleMaps?: string = null;
  telefonKurumsal?: string = null;
  telefonDestek?: string = null;
  telefonSabit?: string = null;
  fax?: string = null;
  emailKurumsal?: string = null;
  emailDestek?: string = null;
  emailKep?: string = null;
  baslik?: string = null;
  altBaslik?: string = null;
  aciklama?: string = null;
  eklenmeTarihi?: Date = null;
  guncellenmeTarihi?: Date = null;
  youtubeAktif:boolean = true;
}
